var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var COMMIT = /^[a-f0-9]{40}$/i;
export var resolveFilterSource = function (source, commit) { return __awaiter(void 0, void 0, void 0, function () {
    var url, _a, owner, repo, parts, refPrefix, sha, split, ref, sha, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = new URL(source);
                if (!['http:', 'https:'].includes(url.protocol)) {
                    throw new Error('Filter source must be an HTTP or HTTPS URL');
                }
                if (commit && !COMMIT.test(commit)) {
                    throw new Error('Enter a full 40-character commit SHA');
                }
                if (url.hostname !== 'raw.githubusercontent.com') {
                    if (commit)
                        throw new Error('Commit selection requires a raw GitHub URL');
                    return [2 /*return*/, { revisionUrl: source }];
                }
                _a = url.pathname.slice(1).split('/'), owner = _a[0], repo = _a[1], parts = _a.slice(2);
                refPrefix = '';
                if (parts[0] === 'refs' && ['heads', 'tags'].includes(parts[1])) {
                    refPrefix = parts.slice(0, 2).join('/') + '/';
                    parts.splice(0, 2);
                }
                if (!owner || !repo || parts.length < 2) {
                    throw new Error('Expected a raw GitHub URL containing a ref and file path');
                }
                if (COMMIT.test(parts[0])) {
                    sha = commit !== null && commit !== void 0 ? commit : parts[0];
                    return [2 /*return*/, {
                            revisionUrl: "https://raw.githubusercontent.com/".concat(owner, "/").concat(repo, "/").concat(sha, "/").concat(parts.slice(1).join('/')),
                            commit: sha,
                        }];
                }
                split = parts.length - 1;
                _b.label = 1;
            case 1:
                if (!(split >= 1)) return [3 /*break*/, 6];
                ref = decodeURIComponent(parts.slice(0, split).join('/'));
                sha = ref;
                if (!!COMMIT.test(ref)) return [3 /*break*/, 4];
                return [4 /*yield*/, fetch("https://api.github.com/repos/".concat(owner, "/").concat(repo, "/commits/").concat(encodeURIComponent(refPrefix + ref)))];
            case 2:
                response = _b.sent();
                if (response.status === 404 || response.status === 422)
                    return [3 /*break*/, 5];
                if (!response.ok) {
                    throw new Error("Could not resolve GitHub revision (".concat(response.status, "). Please retry later or use a commit-pinned raw URL."));
                }
                return [4 /*yield*/, response.json()];
            case 3:
                sha = (_b.sent()).sha;
                if (!COMMIT.test(sha))
                    throw new Error('GitHub returned an invalid commit');
                _b.label = 4;
            case 4: return [2 /*return*/, {
                    revisionUrl: "https://raw.githubusercontent.com/".concat(owner, "/").concat(repo, "/").concat(commit !== null && commit !== void 0 ? commit : sha, "/").concat(parts.slice(split).join('/')),
                    commit: commit !== null && commit !== void 0 ? commit : sha,
                }];
            case 5:
                split--;
                return [3 /*break*/, 1];
            case 6: throw new Error('Could not resolve the GitHub branch or tag');
        }
    });
}); };
